module.exports = __webpack_public_path__ + "static/media/linkedin-link.b68152cf.svg";